import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        isOrLogin: localStorage.getItem("isOrLogin") || "",
        curLocale: localStorage.getItem("curLocale") || "zh-CN",  //zh-CN'简体中文；zh-TW'繁体中文
        userInfo: JSON.parse(localStorage.getItem("userInfo") || "null"), // 添加用户信息
    },
    mutations: {
        //是否登录
        ISLOGIN(state, str){
            localStorage.setItem('isOrLogin', str);
            state.isOrLogin = str;
        },
        //当前语言
        CURLOCALE(state, str) {
            localStorage.setItem('curLocale', str);
            state.curLocale = str;
        },
        // 设置用户信息
        SET_USER_INFO(state, userInfo) {
            if (userInfo) {
                localStorage.setItem('userInfo', JSON.stringify(userInfo));
                state.userInfo = userInfo;
            } else {
                localStorage.removeItem('userInfo');
                state.userInfo = null;
            }
        },
        // 清除用户信息（退出登录）
        CLEAR_USER_INFO(state) {
            localStorage.removeItem('userInfo');
            localStorage.removeItem('newsWebToken');
            localStorage.removeItem('isOrLogin');
            state.userInfo = null;
            state.isOrLogin = "";
        }
    },
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js